<template>
  <NuxtLink v-bind="formattedProps">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
/**
 * API Link model does not comply with vue-router Link type.
 * We are adding this code to align the behavior of Links with "useRouter".
 */
import { computed } from 'vue'

import type { Location } from '@ds/types/Location'

import type { NuxtLinkProps } from '../types/NuxtLinkProps'
import { toNuxtLink } from '../utils/toNuxtLink'

interface CustomLinkProps extends Omit<NuxtLinkProps, 'to'> {
  to: NuxtLinkProps['to'] | Location
}

/**
 * prefect and noPrefect props can't be used together.
 * Default props will set both to false which will lead to a warning.
 * We deprecate the "noPrefetch" in favor of `prefetch=false`.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { noPrefetch, ...originalProps } = defineProps<CustomLinkProps>()

const formattedProps = computed(() => ({
  ...originalProps,
  to: originalProps.to ? toNuxtLink(originalProps.to) : undefined,
}))
</script>
